'use client';
import { BottomSheet } from '@/components/ui';
import { AchievementModal } from './AchievementModal';
import type { MergedAchievement } from '../hooks/useMyAchievements';

export function AchievementDetailSheet({
  achievementKey,
  onClose,
  viewerIsOwner,
  ownerAchievement = null,
}: {
  achievementKey: string | null;
  onClose: () => void;
  viewerIsOwner: boolean;
  ownerAchievement?: MergedAchievement | null;
}) {
  return (
    <BottomSheet
      isOpen={!!achievementKey}
      onClose={onClose}
      title=""
      hideHeader
      panelClassName="!bg-[#141414]"
      bodyClassName="!px-0"
    >
      {achievementKey && (
        <AchievementModal
          achievementKey={achievementKey}
          viewerIsOwner={viewerIsOwner}
          ownerAchievement={ownerAchievement}
        />
      )}
    </BottomSheet>
  );
}
